/**
 * Maps API `code` from docs/ERROR_CODES.md to user-visible copy when `reason` is missing.
 * Prefer server `reason` when present (see formatAuthFailureMessage).
 */

const MESSAGE_BY_CODE = {
  login_missing_fields: 'Please enter your email and password.',
  invalid_credentials: 'Incorrect email or password.',
  google_signin_not_configured: 'Google sign-in is not enabled on the server. Contact support.',
  missing_google_credential: 'Google sign-in did not complete. Please try again.',
  oauth_client_mismatch: 'Google sign-in does not match this app’s configuration. Contact support.',
  token_expired: 'Your Google sign-in expired. Please try signing in again.',
  invalid_token: 'Google could not verify your sign-in. Please try again.',
  google_unreachable: 'Could not reach Google to verify sign-in. Try again in a few minutes.',
  missing_email: 'Google did not provide an email for this account.',
  email_not_verified: 'Your Google email must be verified before you can sign in.',
  unauthorized_account: 'This Google account is not authorized yet. Ask an administrator to add your email, or use email and password if you have an account.',
  signup_disabled: 'New sign-ups are disabled.',
  signup_missing_fields: 'Please fill in all required sign-up fields.',
  invalid_license_key: 'That license key is not valid.',
  email_already_registered: 'That email is already registered.',
  invalid_authentication_header: 'Your session is invalid. Please sign in again.',
  invalid_authentication_token: 'Your session has expired or is invalid. Please sign in again.',
  invalid_current_password: 'The current password is incorrect.',
};

const GENERIC_BY_HTTP = {
  400: 'Something was wrong with the request. Please try again.',
  401: 'Sign-in was not accepted. Please try again.',
  403: 'You are not allowed to sign in this way. Contact support if you need access.',
  500: 'The server had a problem. Please try again later.',
  503: 'Sign-in is temporarily unavailable. Please try again later.',
};

/**
 * @param {object|null|undefined} body - Parsed JSON from login/verify (may include status, code, reason)
 * @param {number|null|undefined} httpStatus - HTTP status if known
 */
export function formatAuthFailureMessage(body, httpStatus) {
  if (body && typeof body === 'object') {
    const r = body.reason;
    if (typeof r === 'string' && r.trim().length > 0) {
      return r.trim();
    }
    const code = body.code;
    if (typeof code === 'string' && MESSAGE_BY_CODE[code]) {
      return MESSAGE_BY_CODE[code];
    }
  }
  if (httpStatus != null && GENERIC_BY_HTTP[httpStatus]) {
    return GENERIC_BY_HTTP[httpStatus];
  }
  return 'Sign-in failed. Please try again.';
}
